<template>
  <div class="select-game">
    <h3 class="choose-game-title" v-if="gameHistory.length">
      {{ letter.recentPlay }}
    </h3>
    <div v-if="gameHistory.length">
      <div class="game-box">
        <div
          class="game-logo j-select-game"
          v-for="(item, indexItem) in gameHistory"
          v-on:click="selectGame(item.GAME_ID)"
          :data-gameid="item.GAME_ID"
          :key="indexItem"
        >
          <img class="img" :src="item.PIC_URL || defaultIcon" />
          <p class="name">{{ item.REAL_NAME }}</p>
        </div>
      </div>
    </div>
    <h3 class="choose-game-title" v-if="gameLists.length">
      {{ gameHistory.length ? letter.moreGames : letter.creatework_gameHolder }}
    </h3>
    <div v-if="gameLists.length">
      <div v-for="(boxItem, index) in gameLists" class="game-box" :key="index">
        <div
          class="game-logo j-select-game"
          v-for="(item, indexItem) in boxItem"
          v-on:click="selectGame(item.GAME_ID)"
          :data-gameid="item.GAME_ID"
          :key="indexItem"
        >
          <img class="img" :src="item.PIC_URL || defaultIcon" />
          <p class="name">{{ item.REAL_NAME }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { EventBus } from '../../utiles/eventbus.js';
import {
  UPDATE_GAMEID,
  GET_SERVER_LIST,
  DEFAULT_ICON,
  GET_SEPC_GAME_INFO
} from '../../store/web/webStore';
import { deviceDirectionPortrait } from '../../utiles/device';
import globalConfig from '../../utiles/globalConfig';
import { errorReport404 } from '@utiles/errorReport';

export default {
  name: 'selectGamePage',
  data() {
    return {
      preCount: 4,
      defaultIcon: DEFAULT_ICON
    };
  },
  mounted() {
    this.preCount = deviceDirectionPortrait() ? 3 : 4;

    if (window.onorientationchange) {
      window.addEventListener(
        'orientationchange',
        () => {
          this.preCount = deviceDirectionPortrait() ? 3 : 4;
        },
        false
      );
    } else {
      window.addEventListener(
        'resize',
        () => {
          this.preCount = deviceDirectionPortrait() ? 3 : 4;
        },
        false
      );
    }
  },
  computed: {
    letter() {
      return this.$store.state.letter;
    },
    gameLists() {
      let res = [];
      let resI = 0;
      let i = this.preCount;
      let gameLists = this.$store.state.gameList;
      let keys = Object.keys(gameLists);
      let showGameList = {};
      keys.forEach(key => {
        let cur = gameLists[key];
        if (+cur.WEB_THIRD_SWITCH !== 0) {
          showGameList[key] = cur;
        }
      });
      /* eslint-disable no-unused-vars */
      for (let key in showGameList) {
        if (i === this.preCount) {
          res.push([showGameList[key]]);
          i--;
        } else {
          res[resI].push(showGameList[key]);
          i--;
          if (i === 0) {
            resI += 1;
            i = this.preCount;
          }
        }
      }
      // 如果没有最近玩过，且游戏列表只有一个游戏，则自动选上
      if (res.length === 1 && res[0].length === 1 && !this.gameHistory.length) {
        this.selectGame(res[0][0].GAME_ID);
      }
      return res;
    },
    gameHistory() {
      let res = [];
      let historyList = this.$store.state.gameHistory;
      for (let index in historyList) {
        if (res.length < 3) {
          res.push(historyList[index]);
        } else {
          break;
        }
      }
      // 如果游戏列表为空，且最近玩过只有一个游戏，则自动选上
      if (res.length === 1 && !this.gameLists.length) {
        this.selectGame(res[0].GAME_ID);
      }
      return res;
    }
  },
  methods: {
    selectGame(gameid) {
      this.$store.dispatch(UPDATE_GAMEID, gameid).then(async () => {
        // if (this.gameLists.length === 1 && this.gameLists[0].length === 1) {
        let canContinue = await this.$store.dispatch(GET_SEPC_GAME_INFO, {
          gameId: gameid
        });
        if (!canContinue) {
          let hostName = globalConfig.getMainHost();
          if (
            hostName === atob('M3N5dWEuY29t') ||
            hostName === atob('YmxhbmNvem9uZS5jb20=')
          ) {
            // 其实404路径不存在，后端根据ip跳转真实404
            errorReport404();
            window.location.href = `//www.${hostName}/404`;
          } else if (hostName === atob('c2xmdW50YXAuY29t')) {
            errorReport404();
            window.location.href = `//www.${hostName}/slfuntap/page404`;
          } else {
            errorReport404();
            window.location.href = `//www.${hostName}/page404`;
          }
          return;
        }
        // }
        this.$store.dispatch(GET_SERVER_LIST);
      });
      EventBus.$emit('updateLogo', gameid);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/webStore.scss';
.select-game {
  overflow: hidden;
}
.choose-game-title {
  color: $font;
  margin: 0 auto 2vh;
  font-size: 2.2vh;
  font-family: 'SourceHanSansCN-Bold';
}

.game-box {
  overflow: hidden;
}
.game-logo {
  float: left;
  margin-right: 1.6vh;
  margin-bottom: 2.3vh;
  cursor: auto;
  font-size: 1.6vh;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  &:nth-child(4n) {
    margin-right: 0;
  }
  $w: 24vw;
  $mw: 14vh;
  .img {
    width: $w;
    height: $w;
    border-radius: 20%;
    margin-bottom: 1vh;
    border: 1px solid $grey;
    transition: all 0.2s;
    max-width: $mw;
    max-height: $mw;
    overflow: hidden;
  }

  .img[src=''],
  img:not([src]) {
    opacity: 0;
  }
  .name {
    text-align: center;
    margin: 0 auto;
    color: $font;
    transition: all 0.2s;
    font-family: 'SourceHanSansCN-Bold';
    text-overflow: clip;
    white-space: normal;
    width: $w;
    max-width: $mw;
    font-size: 1.6vh;
    -webkit-text-size-adjust: none;
  }
  &:hover {
    cursor: pointer;
    .img {
      cursor: pointer;
      border-color: $green;
    }
    .name {
      cursor: pointer;
      color: $green;
    }
  }
}

.game-logo.cur {
  .img {
    border: 1px solid $green;
  }
  .name {
    color: $green;
  }
}

@media screen and (orientation: landscape) {
  .game-logo {
    $w: 18vh;
    .img {
      width: $w;
      height: $w;
      max-width: auto;
      max-height: auto;
    }
    .name {
      width: $w;
      max-width: auto;
    }
  }
}
</style>
